export default __webpack_public_path__ + "static/media/Biology_01_06.28355701.png";